module.exports = __webpack_public_path__ + "img/banner-3-1@2x.27bcc988.jpg";